import { Builder } from '@builder.io/sdk';
import { BREADCRUMB_COMPONENT_NAME, BREADCRUMB_MODEL_NAME, Breadcrumbs } from './Breadcrumbs';

const BreadcrumbsConfig = {
  name: BREADCRUMB_COMPONENT_NAME,
  inputs: [
    {
      name: 'pageTitle',
      type: 'string',
    },
    { name: 'breadcrumb', type: 'reference', model: BREADCRUMB_MODEL_NAME },
  ],
};

Builder.registerComponent(Breadcrumbs, BreadcrumbsConfig);
